/**
 * Constants
 * */
export const moduleName = `authenticityToken`;

/**
 * Reducer
 * */

export default function reducer(state = ``, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const authenticityTokenSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
